import {HomepageCarouselSlide} from '../../models/airtable';

export type CarouselSlide = HomepageCarouselSlide;

export interface HomepageCarouselProps {
  slides: CarouselSlide[];
  isLoading?: boolean;
  onSlidePress?: (pageLink: string) => void;
  testID?: string;
}

/**
 * Returns the best available image URL for a slide.
 * Uses heroImageWeb on desktop, heroImage on mobile.
 */
export const getSlideImageUrl = (
  slide: CarouselSlide,
  isWebDesktop?: boolean,
): string | undefined => {
  if (isWebDesktop) {
    return slide.heroImageWeb?.url ?? slide.heroImage?.url;
  }
  return slide.heroImage?.url;
};
